import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { Label, Text } from 'reaxl';

/**
 *  Displays an inventory label indicating that the listing is likely to sell quickly
 */
function HotCar(_ref) {
  let {
    description,
    label = 'High Demand',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, Object.assign({
    "data-cmp": "hotCar",
    weight: "bold",
    bsStyle: "brand"
  }, rest), label), description && /*#__PURE__*/_jsx(Text, {
    className: "margin-left-2",
    color: "subdued-lightest"
  }, void 0, description));
}
export default HotCar;